import React from 'react';
import Navbar from '../components/Navbar';
import HeroBanner from '../components/HeroBanner';
import Footer from '../components/Footer';
import Breadcrumb from '../components/Breadcrumb';
import CardsSection from '../components/CardsSection';
import CarouselSection from '../components/CarouselSection';
import Showcase from '../components/Showcase';
import { Box, Typography } from '@mui/material';
import { newsItems, eventItems } from '../data/SiteData';

const cardData = [
  {
    title: 'News',
    description: 'Keep up to date with all the latest news about research into the human immune system',
    color: '#489596',
    buttonText: 'View All News',
    link: '/news-events/news',
  },
  {
    title: 'Events',
    description: 'Keep up to date with all the latest news about research into the human immune system',
    color: '#E67350',
    buttonText: 'View All Events',
    link: '/news-events/events',
  },
];

const NewsEvents = () => {
    // Breadcrumb items
    const breadcrumbItems = [
        { title: 'Home', path: '/' },
        { title: 'News & Events', path: '/news-events' },
    ];

    return (
        <>
            <Navbar />
            <HeroBanner
                heroTitle="News & Events"
                heroDescription="Catch up on all the latest news and events."
                imageUrl="/images/digiTwins.png"
                height="165px"
            />
            <Breadcrumb items={breadcrumbItems} />
            <CardsSection cardData={cardData} />
            <CarouselSection title="Latest News" items={newsItems} backgroundStyle="grey"/>
            <Showcase items={eventItems} />
            <Footer />
        </>
    );
};

export default NewsEvents;
